import ContentLoader from "react-content-loader";

const SkeletonCourseCard = () => (
  <div
    className="course-card m-2"
    style={{ width: "250px", marginBottom: "16px" }}
  >
    <ContentLoader
      speed={2}
      width={250}
      height={200}
      viewBox="0 0 150 200"
      backgroundColor="var(--primaryColor)"
      foregroundColor="#e0e0e0"
    >
      <circle cx="75" cy="50" r="50" />
      <rect x="0" y="130" rx="4" ry="4" width="180" height="20" />
      <rect x="0" y="160" rx="4" ry="4" width="120" height="16" />
    </ContentLoader>
  </div>
);

export default SkeletonCourseCard;
